import { render, staticRenderFns } from "./CustomPayment-Accelerant-Ax.vue?vue&type=template&id=700b1f84&scoped=true&"
import script from "./CustomPayment-Accelerant-Ax.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-Accelerant-Ax.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-Accelerant-Ax.vue?vue&type=style&index=0&id=700b1f84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b1f84",
  null
  
)

export default component.exports